'use client';

import { Users, MapPinHouse, LayoutDashboard } from 'lucide-react';

type NavigationItemShape = {
  name: string;
  href: string;
  icon: React.ForwardRefExoticComponent<
    React.SVGProps<SVGSVGElement> & {
      title?: string | undefined;
      titleId?: string | undefined;
    }
  >;
  activeSegment: string | null;
};

// TODO: Extract this to menus? And put it on the server
export const navigation = [
  {
    name: 'Dashboard',
    href: '/',
    icon: LayoutDashboard,
    activeSegment: null,
  },
  {
    name: 'Properties',
    href: '/properties',
    icon: MapPinHouse,
    activeSegment: 'properties',
  },
  {
    name: 'Agents',
    href: '/agents',
    icon: Users,
    activeSegment: 'agents',
  },
  // { name: 'Projects', href: '#', icon: FolderIcon, current: false },
  // { name: 'Calendar', href: '#', icon: CalendarIcon, current: false },
  // { name: 'Documents', href: '#', icon: DocumentDuplicateIcon, current: false },
  // { name: 'Reports', href: '#', icon: ChartPieIcon, current: false },
] as const satisfies readonly NavigationItemShape[];

export type NavigationItems = typeof navigation;
